export const EMPTY_RANGE = [null, null];

const isNil = (value) => value === null || value === undefined;

const emptyValueFor = (filter) => {
  if (filter.type === "range") {
    return EMPTY_RANGE;
  }

  if (filter.type === "singleSelect") {
    return "";
  }

  return [];
};

export const resolveFilterValue = (filter, procedureFilters) =>
  procedureFilters?.[filter.field] ?? emptyValueFor(filter);

export const formatRangeValue = (filter, [start, end]) => {
  const unit = filter.unit ?? "";

  if (isNil(start) && isNil(end)) {
    return "Any";
  }

  if (isNil(end)) {
    return `≥ ${start}${unit}`;
  }

  if (isNil(start)) {
    return `≤ ${end}${unit}`;
  }

  return `${start}${unit} - ${end}${unit}`;
};

export const isFilterAtDefault = (filter, value) => {
  if (filter.type === "range") {
    const [start, end] = value;

    return isNil(start) && isNil(end);
  }

  if (filter.type === "singleSelect") {
    return isNil(value) || value === "";
  }

  const allSelected =
    filter.allSelectedMeansAny !== false &&
    value.length === filter.options.length;

  return value.length === 0 || allSelected;
};

export const formatFilterSummary = (filter, value) => {
  const label = filter.summaryLabel ?? filter.label;

  if (isFilterAtDefault(filter, value)) {
    return `${label}: Any`;
  }

  if (filter.type === "range") {
    return `${label} (${formatRangeValue(filter, value)})`;
  }

  if (filter.type === "singleSelect") {
    const selectedOption = filter.options.find(
      (option) => option.value === value
    );

    return `${label}: ${selectedOption?.label ?? value}`;
  }

  const selectedLabels = filter.options
    .filter((option) => value.includes(option.value))
    .map((option) => option.label);

  return `${label}: ${selectedLabels.join(", ")}`;
};
